import { RestClient } from './RestClient'
import store from 'src/store'

export class ProjectsClient extends RestClient {
  /**
   * Projects constructor
   *
   * @constructor
   */
  constructor () {
    super()

    let currentTeam = store.getters.activeTeam
    this.baseUrl = `/teams/${currentTeam.id}/projects`
  }

  /**
   * Get a list of all projects for the current company
   *
   * @returns {AxiosPromise}
   */
  list () {
    return this.call('get', this.baseUrl)
  }

  /**
   * Show the specified projects
   *
   * @param {(...number|number[])} id - Projects to show
   *
   * @returns {AxiosPromise}
   */
  get (...id) {
    return this.call('get', `${this.baseUrl}/${this.parseAndJoin(id)}`)
  }

  /**
   * Create a new project
   *
   * @param {Object} data - Project info
   *
   * @returns {AxiosPromise}
   */
  create (data) {
    return this.call('post', this.baseUrl, data)
  }

  /**
   * Update an existing project
   *
   * @param {number} projectId - Project id
   * @param {Object} data   - Project info
   *
   * @returns {AxiosPromise}
   */
  update (projectId, data) {
    return this.call('patch', `${this.baseUrl}/${projectId}`, data)
  }

  /**
   * Delete the specified projects
   *
   * @param {(...number|number[])} projectId - Projects which should be deleted
   *
   * @returns {AxiosPromise}
   */
  destroy (...projectId) {
    return this.call('delete', `${this.baseUrl}/${this.parseAndJoin(projectId)}`)
  }

  /**
   * Search for projects
   *
   * @param query
   * @returns {AxiosPromise}
   */
  search (query) {
    this.params.q = query

    return this.call('get', `${this.baseUrl}/search`)
  }

  /**
   * Get all open entries of the project
   *
   * @param {number} projectId
   * @param {string} mode
   * @returns {AxiosPromise}
   */
  openEntries (projectId, mode) {
    this.params.mode = mode

    return this.call('get', `${this.baseUrl}/${projectId}/open-time-entries`)
  }
}
